import { render, staticRenderFns } from "./BoxGroup.vue?vue&type=template&id=3d162ca0&"
import script from "./BoxGroup.vue?vue&type=script&lang=js&"
export * from "./BoxGroup.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports